// Shown on every screen while an operator works inside a client's case:
// whose case this is, and the way back to the case list.

import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../lib/auth";
import { clearCaseState, clearOperatorSession, isOperatorInCase, readOperatorSession } from "../lib/operator";

export function OperatorBar() {
  const navigate = useNavigate();
  const { session, signIn, signOut } = useAuth();
  if (!isOperatorInCase(session)) return null;

  const backToCases = () => {
    const op = readOperatorSession();
    clearCaseState();
    clearOperatorSession();
    if (!op || new Date(op.expiresAt).getTime() < Date.now()) {
      signOut();
      navigate("/sign-in");
      return;
    }
    signIn({
      access_token: op.token,
      token_type: "Bearer",
      expires_at: op.expiresAt,
      tenant_id: op.tenantId,
      tenant_display_name: op.tenantDisplayName,
      user_email: op.userEmail,
      role: op.role,
    });
    navigate("/admin");
  };

  return (
    <div
      role="status"
      className="fixed left-3 bottom-3 z-[60] flex items-center gap-3 rounded-full pl-4 pr-1.5 py-1.5 text-small text-white shadow-lg max-w-[calc(100vw-24px)]"
      style={{ background: "#1f2a22" }}
    >
      <span className="truncate">
        <span className="opacity-70">Admin · </span>
        <b>{session?.tenantDisplayName || "Client"}</b>
        <span className="opacity-70">'s case</span>
      </span>
      <button type="button" onClick={backToCases} className="shrink-0 h-8 px-3 rounded-full bg-white/15 hover:bg-white/25 font-semibold inline-flex items-center gap-1.5 focus-ring">
        <ArrowLeft className="w-3.5 h-3.5" aria-hidden /> All cases
      </button>
    </div>
  );
}
